export const INVALID_ACCESS_TOKEN = "token_not_valid"
export const INVALID_REFRESH_TOKEN = "refresh_token_not_valid"
